import Scooby from './Scooby';
import Shaggy from './Shaggy';
import Plate from './Plate';
import Splash from './Splash';
import PointsCloud from './ui/PointsCloud';

export default class Scene extends Phaser.Group {
  constructor(game) {
    super(game);

    //
    this.foodGood = 0; // number of good food in a row
    this.foodBad = 0; // number of bad food in a row
    this.gameFinished = false;

    //
    this.onMealOnPosition = new Phaser.Signal();
    this.onGetPoint = new Phaser.Signal();

    // wall
    this.wall = this.game.make.image(this.game.defaultWidth / 2, 0, 'foodgame_wall');
    this.wall.anchor.set(0.5, 0);

    // chairs
    this.chairLeft = this.game.make.image(426, 358, 'foodgame_elements', 'chair.png');
    this.chairRight = this.game.make.image(1189, 358, 'foodgame_elements', 'chair.png');
    this.chairRight.scale.x = -1;

    // characters
    this.shaggy = new Shaggy(this.game, 620, 514);
    this.scooby = new Scooby(this.game, 1012, 606);

    // table
    this.tableRight = this.game.make.image(
      this.game.defaultWidth / 2 - 1,
      512,
      'foodgame_elements',
      'table.png'
    );
    this.tableRight.scale.x = -1;
    this.tableRight.anchor.set(1, 0);

    this.tableLeft = this.game.make.image(
      this.game.defaultWidth / 2,
      512,
      'foodgame_elements',
      'table.png'
    );
    this.tableLeft.anchor.set(1, 0);

    // plates container
    this.container = this.game.make.group();
    this.container.position.set(this.game.defaultWidth / 2, 640);
    this.plates = [];
    for (let i = 0; i < 2; i++) {
      let plate = new Plate(this.game, this);
      this.plates.push(plate);
      this.container.addChild(plate);
      plate.onPosition.add(this.handlePlateOnPosition, this);
      plate.onFoodUp.add(this.handleFoodUp, this);
      plate.onFoodDown.add(this.handleFoodDown, this);
    }
    this.plateInd = -1;

    // vignette
    this.vignette = this.game.make.image(0, 0, 'foodgame_vignette');

    //
    this.addChild(this.wall);
    this.addChild(this.chairLeft);
    this.addChild(this.chairRight);
    this.addChild(this.shaggy);
    this.addChild(this.shaggy.arm);
    this.addChild(this.scooby);
    this.addChild(this.scooby.arm);
    this.addChild(this.tableLeft);
    this.addChild(this.tableRight);
    this.addChild(this.shaggy.hand);
    this.addChild(this.scooby.hand);
    this.addChild(this.container);
    this.addChild(this.vignette);

    //
    this.game.scale.onSizeChange.add(this.positionElements, this);
    this.positionElements();

    //
    this.shaggy.onNodEnd.add(this.handleNodEnd, this);
  }

  positionElements() {
    this.vignette.x = (this.game.defaultWidth - this.game.width) / 2;
    this.vignette.width = this.game.width;
  }

  getFoodType() {
    let isGood = true;
    if (this.foodBad == 2) {
      this.foodBad = 0;
      this.foodGood = 0;
      isGood = true;
    } else if (this.foodGood == 4) {
      this.foodBad = 0;
      this.foodGood = 0;
      isGood = false;
    } else {
      isGood = Math.random() < 0.75;
    }

    isGood ? this.foodGood++ : this.foodBad++;

    return isGood;
  }

  start() {
    this.nod();
  }

  stop() {
    // stop all tweens and animations
    console.log('stop');
    this.gameFinished = true;
    this.shaggy.stop();
    this.scooby.stop();
    this.plates[0].stop();
    this.plates[1].stop();
  }

  nod() {
    this.shaggy.nod();
    this.scooby.nod();
  }

  handleNodEnd() {
    this.serveNewMeal();
  }

  serveNewMeal() {
    if (this.plateInd >= 0) {
      this.plates[this.plateInd].goOut();
    }
    this.plateInd = (this.plateInd + 1) % this.plates.length;
    this.plates[this.plateInd].goIn();
  }

  handlePlateOnPosition() {
    this.shaggy.leanFront();
    this.scooby.leanFront();
    this.onMealOnPosition.dispatch();
  }

  feed() {
    let plate = this.plates[this.plateInd];
    plate.throwUp();
    if (!plate.isGood) {
      this.shaggy.duck();
      this.scooby.duck();
      this.shaggy.onActionEnd.add(this.handleActionEnd, this);
    }
  }

  throwAway() {
    let plate = this.plates[this.plateInd];
    plate.throwDown();

    this.game.sounds.playSpriteSFX('swoosh', { spriteID: 'game_audiosprite' });
  }

  leanBack() {
    this.shaggy.leanBack();
    this.scooby.leanBack();
    this.shaggy.onActionEnd.add(this.handleActionEnd, this);
  }

  handleActionEnd() {
    this.shaggy.onActionEnd.remove(this.handleActionEnd, this);
    this.scooby.onActionEnd.remove(this.handleActionEnd, this);

    if (!this.gameFinished) {
      console.log('nod');
      this.nod();
    }
  }

  handleFoodUp(food, foodAtlas, foodKey) {
    let plate = this.plates[this.plateInd];

    if (plate.isGood) {
      // eat
      // if (Math.random() < 0.5) {
      //   this.shaggy.eat();
      //   this.scooby.leanBack();
      //   this.shaggy.onActionEnd.add(this.handleActionEnd, this);
      // } else {
      //   this.shaggy.leanBack();
      //   this.scooby.eat();
      //   this.scooby.onActionEnd.add(this.handleActionEnd, this);
      // }

      this.shaggy.eat();
      this.scooby.eat(true);
      this.shaggy.onActionEnd.add(this.handleActionEnd, this);

      //
      this.onGetPoint.dispatch();

      // add points cloud
      let cloud = new PointsCloud(this.game, this.game.defaultWidth / 2, 200);
      this.addChild(cloud);
    } else {
      // make splash on wall
      let x = food.x;
      let y = food.worldPosition.y - food.height / 2;

      let splash = new Splash(this.game, x, y, foodAtlas, foodKey);
      this.wall.addChild(splash);
    }
  }

  handleFoodDown() {
    let plate = this.plates[this.plateInd];

    if (plate.isGood) {
      this.shaggy.sad();
      this.scooby.sad();
      this.shaggy.onActionEnd.add(this.handleActionEnd, this);
    } else {
      this.shaggy.leanBack();
      this.scooby.leanBack();
      this.shaggy.onActionEnd.add(this.handleActionEnd, this);

      //
      this.onGetPoint.dispatch();

      // add points cloud
      let cloud = new PointsCloud(this.game, this.game.defaultWidth / 2, 200);
      this.addChild(cloud);
    }
  }

  destroy() {
    this.game.scale.onSizeChange.remove(this.positionElements, this);
    super.destroy();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/food/Scene.js